<template>
  <div class="xml-courseDetails">
    <div class="courseDetails_row">
      <div class="title">
        课程表（共{{ courseList.length }}章{{ currNumber(courseList) }}节课）
      </div>
      <!-- <div class="price">付费</div> -->
    </div>
    <el-collapse v-model="activeNames" @change="handleChange">
      <el-collapse-item
        v-for="(item, index) in courseList"
        :title="item.name"
        :key="index"
        :name="index + 1"
      >
        <div v-for="(items, index) in item.sections" :key="index">
          <div class="row" style="margin-top: 5px">
            <div class="collapse">{{ items.name }}</div>
            <div class="row">
              <img src="@/assets/images/time.png" />
              <div class="collapse">
                {{ getTime(items.duration) }}
              </div>
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- <div class="courseDetails_row" style="margin-top: 10px">
      <div class="title">试卷（共{{ testQuestions.length }}套）</div> -->
      <!-- <div class="price">付费</div> -->
    <!-- </div> -->
    <div
      style="margin-top: 10px"
      v-for="(item, index) in testQuestions"
      :key="index"
    >
      <div class="row">
        <div class="collapse">{{ item.sourceName }}</div>
        <div class="collapse">共{{ item.questionCount || "0" }}题</div>
      </div>
    </div>
    <div class="courseDetails_row" style="margin-top: 20px">
      <div class="title">商品详情</div>
    </div>
    <div class="ql-editor" v-html="introduction"></div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css"; // 引入样式
import "quill/dist/quill.snow.css"; // snow theme
import "quill/dist/quill.bubble.css"; // bubble theme
export default {
  props: {
    courseList: {
      type: Array,
      default: () => [],
    },
    testQuestions: {
      type: Array,
      default: () => [],
    },
    introduction: {
      type: String,
    },
  },
  data() {
    return {
      activeNames: [1],
    };
  },
  watch: {},
  methods: {
    handleChange(val) {
      console.log(val);
    },
    currNumber(list) {
      let number = 0;
      if (list) {
        list.map((item) => {
          number += item.sections.length;
        });
        return number;
      } else {
        return "0";
      }
    },
    getTime(time) {
      let h = parseInt(time / 60 / 60);
      let m = parseInt(time / 60);
      let s = time % 60;
      let date =
        (h > 9 ? h : "0" + h) +
        ":" +
        (m > 9 ? m : "0" + m) +
        ":" +
        (s > 9 ? s : "0" + s);
      return date;
    },
  },
};
</script>
<style lang='scss'>
.xml-courseDetails {
  box-sizing: border-box;
  padding: 15px 20px;
  .courseDetails_row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .title {
      padding: 0 10px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      border-left: 5px solid #2e9adb;
    }
    .price {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ff5353;
      line-height: 26px;
    }
  }
  .collapse {
    padding: 5px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 26px;
  }
  .collapse_size {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 26px;
  }
  .el-collapse-item__header {
    background: #fffefd !important;
  }
  .el-collapse-item__content {
    background: #fffefd !important;
    padding-bottom: 0px;
  }
  .el-collapse-item__wrap {
    border-bottom: 0px;
  }
  .el-collapse-item__header {
    border-bottom: 0px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  //样式穿透
  ::v-deep .el-collapse-item__header {
    // height: 40px;
    line-height: 30px;
    height: auto;
    // padding: 10px 0;
  }
  .el-collapse {
    border: 0;
  }
}
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: #f2f2f2;
  img {
    height: 12px;
    width: 12px;
  }
}
</style>
